export enum BrandPrimaryColorToken {
  brandColorPrimaryPure = '#00BBA7',
  brandColorPrimaryLight = '#F0FDFA',
  brandColorPrimaryMedium = '#009689',
  brandColorPrimaryDark = '#00786F',
}

export default BrandPrimaryColorToken

export type TPrimary =
  | 'brandColorPrimaryPure'
  | 'brandColorPrimaryLight'
  | 'brandColorPrimaryMedium'
  | 'brandColorPrimaryDark'
